import React, { useEffect, useState } from 'react';
import Header from './Header';
import Sidebar from './Sidebar';
import Footer from './Footer';
import Loader from './Loader';
import NotFoundPage from '../pages/admin/NotFound/NotFoundPage';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { setShowNotFoundPage } from '../store/auth/actions';

export default function Layout({ component, resetLoading, sidebar = true, selectionName }) {
  const dispatch = useDispatch();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);
  const [showIconsOnly, setShowIconsOnly] = useState(false);
  const { notFound } = useSelector((state) => state.Auth);

  useEffect(() => {
    dispatch(setShowNotFoundPage(false));
  }, [dispatch, location.pathname]);

  useEffect(() => {
    if (resetLoading) {
      setIsLoading(true);
    }

    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, [resetLoading]);

  return (
    <>
      {notFound ? (
        <NotFoundPage />
      ) : (
        <div className='bg-background text-foreground font-OpenSans fixed h-screen w-screen'>
          {sidebar && (
            <>
              {isLoading ? (
                <Loader />
              ) : (
                <div className={`w-full md:grid h-screen bg-accent transition-all duration-300 ease-in-out ${showIconsOnly ? 'md:grid-cols-[4.5rem_1fr]' : 'md:grid-cols-[15rem_1fr] lg:grid-cols-[16.5rem_1fr]'}`}>
                  <Sidebar showIconsOnly={showIconsOnly} setShowIconsOnly={setShowIconsOnly} />
                  
                  {/* Body Section */}
                  <div className="flex flex-col h-[calc(100vh-3.5rem)] w-full overflow-hidden">
                    <Header showIconsOnly={showIconsOnly} setShowIconsOnly={setShowIconsOnly} selectionName={selectionName} />
                    
                    {/* Main Content Area */}
                    <div className={`flex-grow overflow-y-auto ${location.pathname !== "/power-bi-dashboard"&&  'p-4'}`}>
                      {component}
                    </div>
                  </div>
                </div>
              )}
            </>
          )}
          
          <Footer />
        </div>
      )}
    </>
  );
}
